// filter initialNetworkData by selected society list
const filterNetworkData = (
  groups,
  initialNetworkData,
  mapKey = "label",
  groupKey = "groupName"
) => {
  const groupsChecked = groups
    .filter((sn) => sn.checked)
    .map((snf) => snf[mapKey]);
  // filter networkData by groupName which is selected
  return initialNetworkData.filter(
    (n) => n[groupKey] && groupsChecked.includes(n[groupKey])
  );
};

const addSubGroupKey = (networkData, subGroupKey) => {
  if (!(networkData && Array.isArray(networkData))) return;
  // eslint-disable-next-line consistent-return
  if (!subGroupKey) return networkData;
  // eslint-disable-next-line consistent-return
  return networkData.map((nd) => ({
    ...nd,
    subGroup: nd[subGroupKey],
  }));
};

const transValByKey = (transIndex, mainKey, toKey, safeKey) => {
  if (!(transIndex && mainKey && toKey)) return;
  // eslint-disable-next-line consistent-return
  return transIndex[mainKey] ? transIndex[mainKey][toKey] : safeKey || mainKey;
};

// 把 dataset 中各類別中有 checked 的資料集整合成一個 list   資
const combineDatasetChecked = (dataset = {}, keys = []) => {
  const checkedKey = "checked";
  const dataList = [];
  // 依照 keys 的順序, 從 dataset 中取出資料,過濾 checkedKey, 放進 dataList
  keys.forEach((key) => {
    const curDataset = key in dataset ? dataset[key] : null;
    if (!curDataset) return;
    if (Array.isArray(curDataset)) {
      curDataset.forEach((item) => {
        if (item[checkedKey]) {
          dataList.push(item);
        }
      });
    }
  });
  return dataList;
};

export {
  filterNetworkData,
  addSubGroupKey,
  transValByKey,
  combineDatasetChecked,
};
